import { useContext } from 'react';
import { PlusPageContext } from 'utils/context/plusPage';

/**
 * Hook to easily access the PlusContent context
 */
export default () => useContext(PlusPageContext);